import React from "react";
import { changeParameter } from "../../../api_calls/TableauVisuals";
import { Box } from "@mui/material";
import SingleSelect from "../Selectors/SingleSelect";
import { updateStateData } from "../../../Store/actions";
import { useDispatch, useSelector } from "react-redux";

// Removed: "Relative Difference (in %)" on request
const rankByOptions = ["No Ranking", ...["Absolute Difference (in pp)"].sort()];

const RankByFilter = ({ vizId, reduxKeywordToSaveValue }) => {
  const userStateData = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const [rankSelection, setRankSelection] = React.useState({});
  const [dataLoaded, setDataLoaded] = React.useState(false);

  React.useEffect(() => {
    setRankSelection({ value: rankByOptions[0], label: rankByOptions[0] });

    setTimeout(() => {
      setDataLoaded(true);
    }, 1000);
  }, []);

  return dataLoaded ? (
    <Box sx={{ width: 220 }}>
      <SingleSelect
        enableFullWidth={true}
        label={"Rank By"}
        selectionCheck={(option, value) => option.label === value.label}
        options={rankByOptions.map((rankName) => {
          return { value: rankName, label: rankName };
        })}
        defaultVal={rankSelection}
        disableSearch={true}
        sortOptions={false}
        onChangeCall={(selectedOption) => {
          setRankSelection(selectedOption);
          if (typeof vizId !== "undefined" && vizId !== null) {
            changeParameter("Targeting_Rank By Parameter", selectedOption.value, vizId);
          } else {
            dispatchAction(
              updateStateData({
                [reduxKeywordToSaveValue]: {
                  ...userStateData[reduxKeywordToSaveValue],
                  "rank_by": selectedOption.value,
                },
              })
            );
          }
        }}
      />
    </Box>
  ) : (
    <></>
  );
};

export default RankByFilter;
